export enum ResidenceAndRoomsType {
  studio = 'studio',
  apartment1Bedroom = 'apartment1Bedroom',
  apartment2Bedroom = 'apartment2Bedroom',
  apartment3Bedroom = 'apartment3Bedroom',
  apartment4Bedroom = 'apartment4Bedroom',
  house1Bedroom = 'house1Bedroom',
  house2Bedroom = 'house2Bedroom',
  house3Bedroom = 'house3Bedroom',
  house4Bedroom = 'house4Bedroom',
  assistedLiving = 'assistedLiving',
  officeSpace = 'officeSpace',
  storageUnit5By5 = 'storageUnit5By5',
  storageUnit5By10 = 'storageUnit5By10',
  storageUnit10By20 = 'storageUnit10By20',
}

export enum ResidenceType {
  studio = 'studio',
  apartment = 'apartment',
  house = 'house',
  assistedLiving = 'assistedLiving',
  officeSpace = 'officeSpace',
  storageUnit5By5 = 'storageUnit5By5',
  storageUnit5By10 = 'storageUnit5By10',
  storageUnit10By20 = 'storageUnit10By20',
}

export enum Room {
  bedroom = 'bedroom',
  livingRoom = 'livingRoom',
  kitchen = 'kitchen',
  bathroom = 'bathroom',
  homeOffice = 'homeOffice',
  diningRoom = 'diningRoom',
  hall = 'hall',
  laundryRoom = 'laundryRoom',
  homeGym = 'homeGym',
  attic = 'attic',
  garage = 'garage',
  shed = 'shed',
  outdoor = 'outdoor',
  storageRoom = 'storageRoom',
  workshop = 'workshop',
}
